import React, { useMemo, CSSProperties } from 'react';
import { useDropzone, DropEvent } from 'react-dropzone';

const baseStyle: CSSProperties = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    cursor: 'pointer',
};

const activeStyle: CSSProperties = {
    borderColor: '#2196f3'
};

const acceptStyle: CSSProperties = {
    borderColor: '#00e676'
};

const rejectStyle: CSSProperties = {
    borderColor: '#ff1744'
};

const disabledStyle: CSSProperties = {
    cursor: 'not-allowed',
}

const defaultAccept = [
    'image/*',
    'video/*',
    'audio/*',
    'text/plain', // .txt
    'text/csv', // .csv
    'application/msword', // .doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    'application/vnd.oasis.opendocument.presentation', // .odp
    'application/vnd.oasis.opendocument.spreadsheet', // .ods
    'application/pdf', // .pdf
    'application/vnd.ms-powerpoint', // .ppt
    'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
    'application/vnd.ms-excel', // .xls
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx

].join(',');

export interface DropzoneProps {
    accept?: string;
    onDropAccepted?: (files: File[], event: DropEvent) => void;
    disabled?: boolean;
}

export const Dropzone: React.FC<DropzoneProps> = (props) => {
    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject,
        acceptedFiles
    } = useDropzone({
        accept: props.accept || defaultAccept,
        onDropAccepted: props.onDropAccepted,
        disabled: props.disabled,
    });
  
    const style = useMemo(() => ({
        ...baseStyle,
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {}),
        ...(props.disabled ? disabledStyle: {}),
    }), [
        isDragActive,
        isDragReject,
        isDragAccept,
        props.disabled,
    ]);
    
    // const files = acceptedFiles.map(file => (
    //     <li key={file.lastModified}>
    //     {file.name} - {file.size} bytes
    //     </li>
    // ));
  
    return (
      <section className="container">
        <div {...getRootProps({ className: 'dropzone', style: style })}>
          <input {...getInputProps()} />
          <p>Drag files here, or click to select files</p>
        </div>
        {/* <aside>
          <h4>Files</h4>
          <ul>{files}</ul>
        </aside> */}
      </section>
    );
  }
  